import { defineMessages } from "react-intl";

const messages = defineMessages({
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    rhytPlayStyle: {
        id: "tasks.rhytnotation.rhytPlayStyle",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
});

export default messages;
